import React from 'react';
import { TextField } from '../core-form-fields/BaseTextField';

interface NameFieldProps {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
}

export const NameField: React.FC<NameFieldProps> = ({ 
  value, 
  onChange, 
  required = false 
}) => {
  return (
    <TextField
      id="name"
      label="Name"
      value={value}
      onChange={onChange}
      required={required}
      validation={{
        pattern: /^[A-Za-z\s-]+$/,
        minLength: 2,
        maxLength: 50,
        customValidation: (value) => {
          if (value.trim() !== value) {
            return "Name cannot start or end with whitespace";
          }
          return undefined;
        }
      }}
      placeholder="Enter your name"
    />
  );
};